import CashierServiceModel from "../CashierServiceModel";
import UserModel from "./UserModel";
import CustomerModel from "./CustomerModel";

export default class CustomerContactModel extends CashierServiceModel {

  modelName() {
    return 'customer-contacts';
  }

  defaults() {
    return {
      id: null,
      customer_id: null,
      user_id: null,
      name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      customer: null,
      user: null
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      customer_id: (val) => (this.nullStringMutator(val)),
      user_id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      created_at: (val) => (this.nullStringMutator(val)),
      updated_at: (val) => (this.nullStringMutator(val)),
      deleted_at: (val) => (this.nullStringMutator(val)),
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getUser() {
    return this.getRelatedModel(UserModel, 'user');
  }

  getCustomer() {
    return this.getRelatedModel(CustomerModel, 'customer');
  }

}
